import { useUser } from "@/redux/user";
import { productExperimentsEnabled } from "@/services/productExperiments";
import useProductExperiment from "@/services/useProductExperiment";
import useLearningOverview from "../learning/useLearningOverview";
import GuestProgressInvitation, {
  guestInvitationEligible,
} from "../learning/GuestProgressInvitation";
import DailyPracticeCard from "./DailyPracticeCard";

export default function PracticeInvitationExperiment() {
  return productExperimentsEnabled ? (
    <ExperimentOpportunity />
  ) : (
    <DailyPracticeCard />
  );
}
function ExperimentOpportunity() {
  const { id, memberLoggedIn } = useUser();
  const { data } = useLearningOverview();
  const eligible =
    id != null && (memberLoggedIn ? !!data : guestInvitationEligible(data));
  const experiment = useProductExperiment(
    memberLoggedIn ? "lobby_daily_practice" : "guest_progress_invitation",
    memberLoggedIn,
    eligible,
  );
  return (
    <>
      {/* Guests keep the quiet learning link in both arms. */}
      {!memberLoggedIn && <DailyPracticeCard />}
      <div
        ref={experiment.ref}
        style={
          experiment.active && !experiment.value ? { minHeight: 1 } : undefined
        }
      >
        {memberLoggedIn ? (
          experiment.ready && experiment.value && <DailyPracticeCard />
        ) : (
          <GuestProgressInvitation
            enabled={eligible && experiment.ready && experiment.value}
            entrySource="lobby"
          />
        )}
      </div>
    </>
  );
}
